import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'SmartCal360FilterPipe'
})
export class SmartCal360FilterPipe implements PipeTransform{
    transform(smartCalLicenseList, filterSerialNumber) {
        if(smartCalLicenseList.length===0 || filterSerialNumber===null){
            return smartCalLicenseList;
        }
        else{
            return smartCalLicenseList.filter(a=>{
                return a.ProductSerialNo===filterSerialNumber;
            })
        }
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartcal360/pipes/smartcal360FilterPipe.ts